<main>
  <loading-overlay [isLoading]="isLoading() > 0" />
  <p-toast position="top-center" />

  <div class="content">
    <div class="page__title">
      <div class="page__title_container">
        <div>
          <h1>{{ 'ApAdvances_Title' | translateWF: 'Vendor Advances' }}</h1>
          <p class="page__subtitle">
            {{
              'ApAdvances_Subtitle'
                | translateWF
                  : 'Anticipos a Proveedores — advance payments
            against purchase orders.'
            }}
          </p>
        </div>
        <div class="page__title_buttons">
          <p-button [label]="'ApAdvances_New' | translateWF: 'New advance'" icon="pi pi-plus" (click)="redirectToDetails('new')" />
        </div>
      </div>
    </div>

    <div class="cs-page-list-grid">
      @if (filterConfig() && showFilters()) {
        <div>
          <csl-dynamic-filters [filterConfig]="filterConfig()!" [state]="filterState" />
        </div>
      }

      <p-panel [header]="'ApAdvances_Title' | translateWF: 'Vendor Advances'">
        <ng-template pTemplate="icons">
          <p-button
            [label]="(showFilters() ? 'Common_Hide_Filters' : 'Common_Show_Filters') | translateWF: (showFilters() ? 'Hide Filters' : 'Show Filters')"
            [icon]="showFilters() ? 'pi pi-filter-slash' : 'pi pi-filter'"
            (click)="showFilters.set(!showFilters())"
            variant="outlined"
            size="small"
          />
        </ng-template>
        <p-card data-variant="compact">
          <p-table [value]="advances()" selectionMode="single" [lazy]="true">
            <ng-template pTemplate="header">
              <tr>
                <th>{{ 'ApAdvance_Number' | translateWF: 'Advance #' }}</th>
                <th>{{ 'ApPayment_Provider' | translateWF: 'Provider' }}</th>
                <th>{{ 'ApAdvance_Date' | translateWF: 'Date' }}</th>
                <th class="text-right">{{ 'ApAdvance_Amount' | translateWF: 'Amount' }}</th>
                <th>{{ 'Status' | translateWF: 'Status' }}</th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-rowData>
              @let advance = getRowData(rowData);
              <tr>
                <td>
                  <a class="cs-table-link" (click)="redirectToDetails(advance.id ?? undefined)">{{ advance.number }}</a>
                </td>
                <td>{{ advance.providerName || advance.providerCode }}</td>
                <td>{{ advance.paymentDate | date: 'dd/MM/yyyy' }}</td>
                <td class="text-right">{{ advance.amount | number: '1.2-2' }} {{ currencyLabel(advance.currency) }}</td>
                <td>
                  <p-tag [severity]="statusSeverity(advance.status)" [value]="statusLabel(advance.status)" />
                </td>
              </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="5">{{ 'ApAdvances_NotFound' | translateWF: 'No advances found' }}</td>
              </tr>
            </ng-template>
          </p-table>

          <p-paginator
            [rows]="pageSize()"
            [totalRecords]="totalRecords()"
            [first]="(currentPage() - 1) * pageSize()"
            (onPageChange)="onPageChange($event)"
            [rowsPerPageOptions]="[25, 50, 100]"
          />
        </p-card>
      </p-panel>
    </div>
  </div>
</main>
